@let articleData = articleDataObservable$ | async;
<main class="article-page container">
  @if (articleData) {
  <article class="article"
  [ngClass]="{ 'full-width': !(hasRealContent(articleData?.guidance?.content) || hasRealContent(articleData?.relatedPolicies?.content) || hasAnyQaContent(articleData?.qa)) }">
    <div class="article__wrap">
      <app-article-navigation [currentArticlePath]="codeId"
                              [themeSettings]="themeSettings"
                              [selectedCategory]="selectedCategory"></app-article-navigation>

      <h1 class="article__title">{{articleData?.subCategoryName}}</h1>

      <div class="article__content"
           [innerHTML]="safeSubCategoryContent"></div>

      <app-article-navigation [currentArticlePath]="codeId"
                              [themeSettings]="themeSettings"
                              [selectedCategory]="selectedCategory"></app-article-navigation>
    </div>
  </article>

  <aside *ngIf="(hasRealContent(articleData?.guidance?.content) || hasRealContent(articleData?.relatedPolicies?.content) || hasAnyQaContent(articleData?.qa))" class="sidebar">
    <!-- Guidance -->
    <section *ngIf="hasRealContent(articleData?.guidance?.content)" class="sidebar-item"
             [style.backgroundColor]="themeSettings.guidance">
       <!-- <h3 class="sidebar-item__title">
        <span class="sidebar-item__icon-title dds-icon dds-icon_lightbulb__l__stroke"></span>
        Guidance
      </h3> -->

      <div class="sidebar-item__content"
           [innerHTML]="safeGuidanceContent"></div>
    </section>

    <!-- Related policies -->
    <section *ngIf="hasRealContent(articleData?.relatedPolicies?.content)" class="sidebar-item" [style.backgroundColor]="themeSettings.policies">
      <h3 class="sidebar-item__title">{{articleData?.relatedPolicies.title}}</h3>

      <div #relatedPoliciesContent class="sidebar-item__content related-policies" [class.expanded]="policiesExpanded">
          <span class="sidebar-item-link__text" [innerHTML]="safeRelatedPoliciesContent"></span>
      </div>

      <dds-button *ngIf="isContentOverflowing" theme="dark" kind="primary"
        class="sidebar-item__btn sidebar-item__btn_show-more" [class.sidebar-item__btn_active]="policiesExpanded" [icon]="policiesExpanded ?
                'dds-icon_chevron_up__s__stroke' : 'dds-icon_chevron_down__s__stroke'" (clicked)="togglePolicies()">
        {{policiesExpanded ? 'Show less' : 'Show more'}}
      </dds-button>
    </section>

    <!-- QA -->
    <section *ngIf="hasAnyQaContent(articleData?.qa)" class="sidebar-item">
      <h3 class="sidebar-item__title">Q & A</h3>

      <dds-accordion class="qa-block"
                     size="lg">

        @for (item of articleData?.qa; track item; let i = $index) {
        @if (hasQaContent(item)) {
        <dds-accordion-item class="qa-item">
          <span header
                class="qa-item__title">{{item.title}}</span>
          <div content
               class="qa-item__content"
               [innerHTML]="safeQaContents[i]"></div>
        </dds-accordion-item>
        }
        }

      </dds-accordion>
    </section>

  </aside>
  }
</main>
